import store from "../store";

// const currencySymbol = process.env.VUE_APP_DEFAULT_CURRENCY_SYMBOL;

const defaultCurrency = process.env.VUE_APP_DEFAULT_CURRENCY ?? "CAD";

const formatCurrency = {
  install: (Vue) => {
    Vue.prototype.$formatCurrency = (value, currency = "CAD") => {
      if (value === null) {
        return "";
      }

      return Vue.prototype.$numberFormat(value, currency ?? defaultCurrency);
      // return `${currencySymbol} ${value.toFixed(2)}`;
    };
  },
};

export default formatCurrency;
